module.exports = __webpack_public_path__ + "static/banner-bg-2545x420-1e57faae70deb9ec56d4e4f4f4d96ab2.jpg";